import { StationInfo } from "../types";

type Props = {
  station: StationInfo;
  onClose: () => void;
  onOpenStation: (id: number | string) => void;
};

export default function StationDock({
  station,
  onClose,
  onOpenStation,
}: Props) {
  return (
    <aside
      className="absolute right-4 top-16 z-[40] w-[420px] max-w-[94vw]"
      style={{
        background: "rgba(8,8,8,0.88)",
        borderRadius: 22,
        boxShadow: "0 10px 40px rgba(0,0,0,.35)",
        backdropFilter: "blur(6px)",
        border: "1px solid rgba(255,255,255,.12)",
        overflow: "hidden",
        animation: "slideIn .22s ease-out",
      }}
    >
      <div
        className="flex items-center justify-between"
        style={{ padding: "12px 16px 0 16px" }}
      >
        <div style={{ color: "#bfbfbf", fontSize: 12 }}>Estación</div>
        <button
          onClick={onClose}
          className="rounded-full"
          style={{
            border: "1px solid rgba(255,255,255,.18)",
            background: "rgba(0,0,0,.6)",
            color: "#fff",
            padding: "6px 10px",
          }}
          title="Cerrar panel"
        >
          ✕
        </button>
      </div>

      <div
        style={{
          padding: "4px 16px 12px 16px",
          color: "#fff",
          fontSize: 22,
          fontWeight: 750,
          lineHeight: 1.2,
        }}
      >
        {station.name}
      </div>

      {station.thumbnail ? (
        <img
          src={station.thumbnail}
          alt={station.name}
          style={{
            width: "calc(100% - 24px)",
            margin: "0 12px",
            display: "block",
            borderRadius: 18,
            border: "1px solid rgba(255,255,255,.08)",
          }}
        />
      ) : null}

      {station.description ? (
        <div
          style={{
            padding: "14px 16px 8px 16px",
            color: "rgba(255,255,255,.92)",
            fontSize: 14.5,
            lineHeight: 1.55,
          }}
        >
          {station.description}
        </div>
      ) : null}

      <div style={{ padding: "16px" }}>
        <button
          onClick={() => station.id != null && onOpenStation(station.id)}
          style={{
            width: "100%",
            background: "#ffffff",
            color: "#000",
            border: "none",
            borderRadius: 12,
            padding: "12px 14px",
            fontWeight: 800,
            cursor: "pointer",
          }}
        >
          Ver estación
        </button>
      </div>
    </aside>
  );
}
